export default __webpack_public_path__ + "static/media/e_wdt_c_2.fe93ecb9.mp3";